@if (loaderService.isLoading | async) {
  <div class="spinner-container">
    <mat-spinner [diameter]="100"></mat-spinner>
  </div>
}
